(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mof-native-video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mof-native-video')) {
    customElements.define('mof-native-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.mof-native-video__toggle');
        this.sourceTemplate = this.querySelector('template[data-video-sources]');
        if (!this.video || !this.button || !this.sourceTemplate || this.abortController) return;
        this.sources = Array.from(this.sourceTemplate.content.querySelectorAll('source'));
        if (!this.sources.length) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.userPlayback = null;
        this.visible = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.userPlayback = this.video.paused;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-has-played', '');
          this.updateControl();
        }, options);
        this.video.addEventListener('pause', () => this.updateControl(), options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-has-played');
          this.button.hidden = true;
          this.updateControl();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        const preferencesChanged = () => {
          this.userPlayback = null;
          this.syncPlayback();
        };
        this.motion.addEventListener('change', preferencesChanged, options);
        this.connection?.addEventListener('change', preferencesChanged, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.syncPlayback();
          }, { threshold: 0 });
          this.observer.observe(this);
        } else {
          this.visible = true;
          this.syncPlayback();
        }
        this.updateControl();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
        this.video?.pause();
      }
      wantsPlayback() {
        const allowAutoplay = !this.motion.matches && !this.connection?.saveData;
        return this.visible && !document.hidden && (this.userPlayback === true || (this.userPlayback !== false && allowAutoplay));
      }
      loadSource() {
        if (this.video.querySelector('source')) return;
        const candidates = this.sources.slice().sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
        const targetWidth = Math.min(this.clientWidth, 1280);
        const selected = candidates.find(source => Number(source.dataset.width) >= targetWidth) || candidates[candidates.length - 1];
        this.video.append(selected.cloneNode(true));
        this.video.load();
      }
      syncPlayback() {
        if (this.wantsPlayback()) {
          this.loadSource();
          this.video.play()?.catch(() => this.updateControl());
        } else {
          this.video.pause();
        }
      }
      updateControl() {
        const playing = !this.video.paused && !this.video.ended;
        this.toggleAttribute('data-playing', playing);
        this.button.setAttribute('aria-pressed', String(playing));
        this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
